"use strict";

var $ = require("jquery");
var MAIN_TEMPLATE = require("../html/UserProfile.html");

require("../style/user-profile.css");
require("../style/close.svg");
require("../style/overlay.png");

var url_table = {
    'dev-1':'https://psuimdevwb8027.morningstar.com/UserProfile.html',
    'qa':'https://identity-qa.morningstar.com/UserProfile.html',
    'stg':'https://identity-stg.morningstar.com/UserProfile.html',
    'uat':'https://identity-uat.morningstar.com/UserProfile.html',
    'prod':'https://identity.morningstar.com/UserProfile.html'
};

function UimUserProfileWidget(params) {
    this.element = params.element;
    this.linkText = params.configuration.linkText;
    this.environment = params.configuration.environment;
    this.showChangeEmail = params.configuration.showChangeEmail;
    this.showChangePassword = params.configuration.showChangePassword;
}

UimUserProfileWidget.prototype.init = function () {
    var self = this;

    this.element.append(MAIN_TEMPLATE);
    this.containerID = "uim-user-profile-";
    this.parameterURL = '';
    this.popupContainer = this.element.find(".uim-user-profile div.uim-user-profile-container");
    this.onlyOneWidget = false;
    this.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


    if(this.showChangeEmail) {
        if (this.showChangePassword) {
            this.containerID += 'both';
        }
        else {
            this.containerID += 'email';
            this.parameterURL += '?email=true';
            this.onlyOneWidget = true;
        }
    } else {
        if(this.showChangePassword){
            this.containerID += 'password';
            this.parameterURL += '?password=true';
            this.onlyOneWidget = true;
        }
        else{
            this.containerID += 'neither';
        }
    }
    var userProfileWrapper = document.getElementById("uim-user-profile");
    this.adjustWrapperHeight(userProfileWrapper);
    userProfileWrapper.setAttribute("id", this.containerID);

    this.userProfileLink = this.element.find(".uim-user-profile #uim-user-profile-link");
    this.userProfileLink[0].innerText = this.linkText;
    this.userProfileLink.on("click", function (e) {
        e.preventDefault();
        self.open();
    });

    $(".uim-user-profile #uim-user-profile-close").on("click", function (e) {
        e.preventDefault();
        self.close();
    });

    if (window.addEventListener) {
        window.addEventListener("message", self.close, false);
    } else {
        //ie
        window.attachEvent("message", self.close);
    }
};

UimUserProfileWidget.prototype.adjustWrapperHeight = function(userProfileWrapper) {
    if (this.onlyOneWidget) {
        if (this.iOS) {
            userProfileWrapper.style['max-height'] = '600px';
        } else {
            userProfileWrapper.style['max-height'] = '420px';
        }
    } else if (this.iOS) {
        userProfileWrapper.style['max-height'] = '950px';
    }
};

UimUserProfileWidget.prototype.open = function() {
    this.createPopup();
    var frame = $('#uim-frame');
    if (this.onlyOneWidget) {
        if (this.iOS) {
            frame.css('height', '550px');
        } else {
            frame.css('height', '375px');
        }
    } else if (this.iOS) {
        frame.css('height', '900px');
    }
    if (this.iOS) {
        var body = $('body');
        this.oldBodyOverflow = body.css('overflow');
        this.oldBodyPosition = body.css('position');
        body.css('overflow', 'hidden');
        body.css('position', 'fixed');
        frame.scrollTop = 0;
    }
    this.popupContainer.css('display','block');
};

UimUserProfileWidget.prototype.close = function() {
    $(".uim-user-profile div.uim-user-profile-container").css('display','none');
    var frame = $('#uim-frame');
    frame.remove();
    if (this.iOS) {
        var body = $('body');
        body.css('overflow', this.oldBodyOverflow);
        body.css('position', this.oldBodyPosition);
    }
};

UimUserProfileWidget.prototype.createPopup = function() {
    var object = document.createElement("object");
    object.setAttribute('data', url_table[this.environment] + this.parameterURL);
    object.setAttribute('id', 'uim-frame');
    object.setAttribute('type', 'text/html');
    document.getElementById(this.containerID).appendChild(object);
};


module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimUserProfileWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/user-profile.js
// module id = 25
// module chunks = 0